import * as CONSTANTS from "../../constants/registerTechConstants";

export type TechCreateAccountRequestActionType = ReturnType<typeof techCreateAccountRequestAction>;
export type CompleteTechProfileActionType = ReturnType<typeof completeTechProfileAction>;
export type FetchStatesActionType = ReturnType<typeof fetchStatesAction>;
export type FetchHireflixLinkActionType = ReturnType<typeof fetchHireflixLink>;
export type UploadResumeActionType = ReturnType<typeof uploadResumeAction>;
export type DeleteResumeActionType = ReturnType<typeof deleteResumeAction>;

export function techCreateAccountRequestAction(data: any) {
  return {
    type: CONSTANTS.SIGN_UP_REQUESTED,
    payload: data,
  } as const;
}

export function completeTechProfileAction(data: {
  techRegistrationPageNo: number;
  userId: number;
}) {
  return {
    type: CONSTANTS.COMPLETE_TECH_PROFILE_REQUEST,
    payload: data,
  } as const;
}

export function fetchStatesAction() {
  return {
    type: CONSTANTS.FETCH_STATES_REQUEST,
  } as const;
}

export function fetchHireflixLink(userId: number) {
  return {
    type: CONSTANTS.FETCH_TECH_HIREFLIX_LINK_REQUEST,
    userId: userId,
  } as const;
}

// --- RESUME
export function uploadResumeAction(data: any) {
  return {
    type: CONSTANTS.UPLOAD_TECH_RESUME_REQUEST,
    payload: data,
  } as const;
}

export function deleteResumeAction(data: any) {
  return {
    type: CONSTANTS.DELETE_TECH_RESUME_REQUEST,
    payload: data,
  } as const;
}
